module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/header/header.component.scss
// module id = ./src/app/modules/common-module/components/header/header.component.scss
// module chunks = 9